import React from 'react'
import { J1DownleftarrowC, J1ToprightarrowC } from '@e3dc-react/icons'
import { makeStyles } from 'tss-react/mui'
import { Box, Typography } from '@mui/material'
import { isNil } from 'lodash'

const useStyles = makeStyles()(theme => ({
  dischargingValues: {
    display: 'flex',
    columnGap: theme.spacing(1),
    rowGap: theme.spacing(0),
    flexWrap: 'wrap',
    '& .MuiSvgIcon-root': {
      width: 14,
      height: 18,
      marginLeft: theme.spacing(0.5),
    },
  },
  dischargingValuesFirst: {
    display: 'inline-flex',
    alignItems: 'end',
    color: theme.palette.text.primary,
    '& svg': {
      marginBottom: theme.spacing(0.5),
    },
  },
  dischargingValuesSecond: {
    display: 'inline-flex',
    alignItems: 'end',
    color: theme.palette.text.primary,
    '& svg': {
      marginBottom: theme.spacing(0.5),
    },
  },
}))

interface WallboxBiDiValuesProps {
  energyAll?: number
  energyDischarged?: number
  formatter: (value: number) => { value: string; unit: string }
}

const WallboxBiDiValues: React.FC<WallboxBiDiValuesProps> = ({ energyAll, energyDischarged, formatter }) => {
  const { classes } = useStyles()
  const formattedDischarged = !isNil(energyDischarged) ? formatter(energyDischarged) : undefined
  const formattedAll = !isNil(energyAll) ? formatter(energyAll) : undefined

  return (
    <Box className={classes.dischargingValues}>
      {formattedDischarged && (
        <Box className={classes.dischargingValuesSecond}>
          <Typography variant="h1" component="span">
            {formattedDischarged.value}
            <Typography variant="h2" component="span">
              {` ${formattedDischarged.unit}`}
            </Typography>
          </Typography>
          <J1ToprightarrowC color="inherit" fontSize="small" />
        </Box>
      )}
      {formattedAll && (
        <Box className={classes.dischargingValuesFirst}>
          <Typography variant="h1" component="span">
            {formattedAll.value}
            <Typography variant="h2" component="span">
              {` ${formattedAll.unit}`}
            </Typography>
          </Typography>
          <J1DownleftarrowC color="inherit" fontSize="small" />
        </Box>
      )}
    </Box>
  )
}

export default WallboxBiDiValues
